
import { Tooltip} from '@mantine/core';
import intl from "react-intl-universal";
import { Check, RubberStampOff } from "tabler-icons-react";



const IdentConfirmButton = (props:any) => {
  

  return (
    <>
   {!props.confirm &&
          <Tooltip label={intl.get('IDENTBUTTONS_TT_IDENT_CONFIRM')} >
            <span>
             <Check size={38} strokeWidth={1} color="green" onClick={() => props.handleOpen()} />
            </span>
          </Tooltip>
          }
          {props.confirm &&
            <Tooltip label={intl.get('IDENTBUTTONS_TT_IDENT_REVERS')} >
                <span>
                 <RubberStampOff color="red" size={38} strokeWidth={1} onClick={() => props.handleOpenDelete()}/>
                </span>
          </Tooltip>
          }
   
    </>
  );
}

export default IdentConfirmButton;